export default __webpack_public_path__ + "static/media/joy_family.747fe11d.png";